<button (menuClosed)="resetValue(config.controlName)"
        [attr.data-test-id]="'hot-'+config.controlName+'-trigger'"
        [class.active]="control?.value !== config.initialValue"
        [matMenuTriggerFor]="input"
        class="chip chip_rect" mat-ripple>{{ config.hotFilter.quickButtonText }}
</button>

<mat-menu #input="matMenu"
          [formGroup]="form"
          class="hot-filter-list-menu hot-filter-list-menu_payment">
  <div (click)="stopPropagation($event)" class="menu-content">
    <app-radio-filter (click)="stopPropagation($event)"
                      [config]="config"
                      [controlName]="config.controlName"
                      [form]="form"></app-radio-filter>

    <button (click)="applyFilterForm()"
            [attr.data-test-id]="'hot-'+config.controlName+'-apply'"
            [disabled]="control?.invalid || notChanged(config.controlName)"
            class="mt-5"
            color="primary"
            mat-raised-button>{{ config.hotFilter.overlayButtonText }}
    </button>
  </div>
</mat-menu>
